module.exports = __webpack_public_path__ + "static/img/zfbpay-icon.cf7cff7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/zfbpay-icon.jpg
// module id = T411
// module chunks = 0